import { useNewDataFormCalculateCargoPickUpStore } from '@/stores/calculateCargoPickup';
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { inject } from 'vue';

export default {
  props: {
    ruleFormRef: Object,
  },

  setup() {
    const dataForm = useNewDataFormCargoPickUpStore();
    const dataFormCalculator = useNewDataFormCalculateCargoPickUpStore();

    const newSubmissionInfo = inject('newSubmissionInfo');

    return {
      dataForm,
      dataFormCalculator,
      newSubmissionInfo,
    };
  },
};
